import type { SupportedLocale } from './getFlattenedLocales'
import { getFlattenedLocales } from './getFlattenedLocales'

export const isSupportedLocale = (
  locale: string | null | undefined,
): locale is SupportedLocale => {
  const flattenedLocales = getFlattenedLocales()

  return flattenedLocales.includes(locale as SupportedLocale)
}
